import React from "react";
import Text from "../../../../../_components/Text";

export default props => {
    return <React.Fragment>
        <Text color="danger">
        *Importante: A versão Easygestor online possui compatibilidade apenas
        com o modelo de certificado A1 e-CNPJ (arquivo PFX). Para outras
        versões, consulte nosso suporte técnico.
      </Text>
      <Text color="danger">
        *Importante: Não é possível recuperar o certificado Digital a partir do
        nosso site, pois não armazenamos o arquivo nem sua senha, por questões
        de segurança.
      </Text>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/views/AppViews/DigitalCertificate/components/Disclaimers/index.jsx